import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=12df8613&scoped=true&"
import script from "./ContactDetail.vue?vue&type=script&lang=js&"
export * from "./ContactDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetail.vue?vue&type=style&index=0&id=12df8613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df8613",
  null
  
)

export default component.exports